import styled from 'styled-components';
import { Card } from 'antd';

export const Container = styled(Card)`
  grid-area: topPostInsta;
  border-top: 4px solid #cd2e92 !important;
  div.ant-card-body {
    div.ant-skeleton-header {
      padding: 0;
    }
    button {
      margin-top: 16px;
      color: #cd2e92;
      border-color: #cd2e92;
    }
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  h4 {
    margin-right: auto;
  }
  img {
    height: 32px;
    width: 32px;
    margin-right: 16px;
  }
  svg {
    color: #cd2e92;
    height: 32px;
    width: 32px;
  }
`;
